import { combineReducers } from 'redux';
// import staticReducer from './static/staticReducer';
import visibilityReducer from './visibility/visibilityReducer';

export default combineReducers({
  // staticData: staticReducer,
  visibility: visibilityReducer,
});



// WEBPACK FOOTER //
// ./src/store/modules/app/appReducer.js